<pre>
    <code *ngFor="let line of (xml$ | async); trackBy: trackByFn">{{line}}</code>
</pre>
